import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { EduSplit } from "./Learning";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Btn, Card, Field, Input, Select, PageTitle, Notice } from "../components/kit";
import { api, parseError } from "../lib/api";
import { useAuth } from "../lib/auth";
import i18n from "../i18n";
import { MyDocs } from "./DocsPages";
import { DataRequests, MyPurchases } from "./LaunchPages";

export const TIME_ZONES = (() => {
  try { return Intl.supportedValuesOf("timeZone"); } catch { return ["UTC", "Europe/London", "Europe/Berlin", "Europe/Moscow", "America/New_York"]; }
})();

export default function Profile() {
  const { t } = useTranslation();
  const { me, setMe } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const u = me.user;
  const init = useMemo(() => ({ first_name: u.first_name || "", surname: u.surname || "", display_name: u.display_name || "", interface_language: u.interface_language || "en",
    material_language: u.material_language || "en", country: u.country || "", city: u.city || "", time_zone: u.time_zone || "UTC", notification_email: u.notification_email || u.email }), [u]);
  const [f, setF] = useState(init);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put("/auth/profile", f);
      setMe(data);
      if (f.interface_language !== i18n.language) {
        localStorage.setItem("valeriia_lang", f.interface_language);
        await i18n.changeLanguage(f.interface_language);
      }
      toast.success(t("profile.saved"));
      if (params.get("welcome")) navigate(u.active_role === "owner" ? "/owner" : "/home");
    } catch (er) {
      toast.error(t(`err.${parseError(er).code}`));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mx-auto max-w-2xl">
      <PageTitle title={t("profile.title")} sub={u.email} />
      {params.get("welcome") && <div className="mb-4"><Notice testid="profile-welcome">{t("profile.welcome")}</Notice></div>}
      <div className="mb-4"><EduSplit /></div>
      <div className="mb-4"><MyDocs /></div>
      <div className="mb-4"><MyPurchases /></div>
      <div className="mb-4"><DataRequests /></div>
      <Card>
        <form onSubmit={save} className="grid gap-4 sm:grid-cols-2">
          <Field label={t("field.first_name")} htmlFor="p-fn"><Input id="p-fn" data-testid="profile-first-name-input" value={f.first_name} onChange={set("first_name")} /></Field>
          <Field label={t("field.surname")} htmlFor="p-sn"><Input id="p-sn" data-testid="profile-surname-input" value={f.surname} onChange={set("surname")} /></Field>
          <Field label={t("field.display_name")} htmlFor="p-dn"><Input id="p-dn" data-testid="profile-display-name-input" value={f.display_name} onChange={set("display_name")} /></Field>
          <Field label={t("field.notification_email")} htmlFor="p-ne"><Input id="p-ne" type="email" data-testid="profile-notification-email-input" value={f.notification_email} onChange={set("notification_email")} /></Field>
          <Field label={t("field.interface_language")} htmlFor="p-il">
            <Select id="p-il" data-testid="profile-interface-language-select" value={f.interface_language} onChange={set("interface_language")}><option value="en">English</option><option value="ru">Русский</option></Select>
          </Field>
          <Field label={t("field.material_language")} htmlFor="p-ml" hint={t("profile.material_hint")}>
            <Select id="p-ml" data-testid="profile-material-language-select" value={f.material_language} onChange={set("material_language")}><option value="en">English</option><option value="ru">Русский</option></Select>
          </Field>
          <Field label={t("field.country")} htmlFor="p-c"><Input id="p-c" data-testid="profile-country-input" value={f.country} onChange={set("country")} /></Field>
          <Field label={t("field.city")} htmlFor="p-ci"><Input id="p-ci" data-testid="profile-city-input" value={f.city} onChange={set("city")} /></Field>
          <Field label={t("field.time_zone")} htmlFor="p-tz">
            <Select id="p-tz" data-testid="profile-time-zone-select" value={f.time_zone} onChange={set("time_zone")}>{TIME_ZONES.map((z) => <option key={z} value={z}>{z}</option>)}</Select>
          </Field>
          <div className="sm:col-span-2"><Btn type="submit" disabled={busy} testid="profile-save-btn">{t("profile.save")}</Btn></div>
        </form>
      </Card>
    </div>
  );
}
